import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import wiseDrivelogoFooter from '../../assets/images/footer/wiseDrivelogoBlueFooter.png';

const HeaderCountrySelect = () => {
  return (
    <header>
      <div className="container">
        <div className="logo">
          <Link to="/">
            <img
              loading="lazy"
              src={wiseDrivelogoFooter}
              alt="company logo"
              className="company-logo"
            />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default HeaderCountrySelect;
